/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const get = (id) => (
  fetch(`/api/public/tags/${id}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
